import { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const EmployeeAdd = () => {
  const URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [positions, setPositions] = useState([]);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobilePhone: "",
    gender: "",
    positionId: "",
    imageFile: null,
  });

  // Fetch positions from API
  useEffect(() => {
    const fetchPositions = async () => {
      try {
        const response = await axios.get(`${URL}/positions`, {
          withCredentials: true,
        });        
        setPositions(response.data.data);
      } catch (error) {
        toast.error("Failed to fetch positions");
      }
    };
    
    fetchPositions();
  }, [URL]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, imageFile: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });

    try {
      await axios.post(`${URL}/employees`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });
      toast.success("บันทึกข้อมูลเรียบร้อยแล้ว");
      navigate("/panel/employee");
    } catch (error) {
      const data = error.response?.data;
      let msg = "บันทึกข้อมูลไม่สำเร็จ";

      if (data) {
        if (Array.isArray(data.errors)) {          
          msg = data.errors.map(e => e.msg).join(", ");
        } else if (data.message) {
          msg = data.message;
        }
      }

      toast.error(msg);
    }
  };

  // const formatPhone = (phone) => {
  //   if (!phone) return '';
  //   // phone เป็น string ตัวเลขยาว 10 ตัว เช่น "0812345678"
  //   return phone.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
  // };  

  return (
    <div>
        <h2 className="text-xl font-bold mb-4">การจัดการข้อมูลพนักงาน</h2>
        <hr className="mb-4"/>      

        <nav className="flex mb-8" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
            <li className="inline-flex items-center">
                <a href="/panel/employee" className="inline-flex items-center font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
                <svg className="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
                </svg>
                ข้อมูลพนักงาน
                </a>
            </li>
            <li aria-current="page">
                <div className="flex items-center">
                <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
                </svg>
                <span className="ms-1 font-medium text-gray-500 md:ms-2 dark:text-gray-400">เพิ่มข้อมูล</span>
                </div>
            </li>
            </ol>
        </nav>

        <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 border border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {/* First Name */}
                <div className="mb-2">
                <label className="block text-gray-700 text-sm font-bold mb-2">ชื่อ *</label>
                <input
                    type="text"
                    name="firstName"
                    maxLength={100}
                    value={formData.firstName}
                    onChange={handleChange}
                    className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                />
                </div>

                {/* Last Name */}
                <div className="mb-2">
                <label className="block text-gray-700 text-sm font-bold mb-2">นามสกุล *</label>
                <input
                    type="text"
                    name="lastName"
                    maxLength={100}
                    value={formData.lastName}
                    onChange={handleChange}
                    className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                />
                </div>


                {/* Email */}
                <div className="mb-2">
                <label className="block text-gray-700 text-sm font-bold mb-2">อีเมล *</label>
                <input
                    type="email"
                    name="email"
                    maxLength={100}
                    value={formData.email}
                    onChange={handleChange}
                    className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                />
                </div>

                {/* Phone */}
                <div className="mb-2">
                <label className="block text-gray-700 text-sm font-bold mb-2">เบอร์โทรศัพท์</label>
                <input
                    type="text"
                    name="mobilePhone"
                    placeholder="เบอร์โทรศัพท์ (เช่น 0868473819)"
                    maxLength={10}              
                    pattern="^[0-9]{10}$"
                    title="รูปแบบเบอร์โทรไม่ถูกต้อง เช่น 0868473819"  
                    value={formData.mobilePhone}
                    onChange={handleChange}
                    className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                </div>

                {/* Position */}
                <div className="mb-2">
                <label className="block text-gray-700 text-sm font-bold mb-2">ตำแหน่ง *</label>
                <select
                    name="positionId"
                    value={formData.positionId}
                    onChange={handleChange}
                    className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                >
                    <option value="">เลือกตำแหน่ง</option>
                    {positions.map((position) => (
                    <option key={position.positionId} value={position.positionId}>
                        {position.positionName}
                    </option>
                    ))}
                </select>
                </div>

                {/* Gender */}
                <div className="mb-2">
                <label className="block text-gray-700 text-sm font-bold mb-2">เพศ *</label>
                <div className="flex gap-4 mt-2">
                    <label className="flex items-center">
                    <input
                        type="radio"
                        name="gender"
                        value="0"
                        checked={formData.gender === "0"}
                        onChange={handleChange}
                        className="mr-2"
                        required
                    />
                    ชาย
                    </label>
                    <label className="flex items-center">
                    <input
                        type="radio"
                        name="gender"
                        value="1"
                        checked={formData.gender === "1"}
                        onChange={handleChange}
                        className="mr-2"
                    />
                    หญิง
                    </label>
                </div>
                </div>


                {/* Image Upload */}
                <div className="mb-2">
                <label className="block text-gray-700 text-sm font-bold mb-2">อัพโหลดรูปภาพ</label>
                <input
                    type="file"
                    name="imageFile"
                    accept="image/*" // Restrict to image files
                    onChange={handleFileChange}
                    className="border border-gray-300 rounded px-4 py-2 w-full"                    
                />
                </div>
            
                {/* isActive */}
                <div className="mb-2">
                    <label className="block text-gray-700 text-sm font-bold mb-2">การอนุมัติ *</label>
                    <div className="flex gap-4 mt-2">
                        <label className="flex items-center">
                        <input
                            type="radio"
                            name="isActive"
                            value="0"
                            checked={formData.isActive === 0} // Compare as a number
                            onChange={(e) =>
                            setFormData({ ...formData, isActive: parseInt(e.target.value, 10) }) // Convert to number
                            }
                            className="mr-2"
                            required
                        />
                        ไม่อนุมัติ
                        </label>
                        <label className="flex items-center">
                        <input
                            type="radio"
                            name="isActive"
                            value="1"
                            checked={formData.isActive === 1} // Compare as a number
                            onChange={(e) =>
                            setFormData({ ...formData, isActive: parseInt(e.target.value, 10) }) // Convert to number
                            }
                            className="mr-2"
                        />
                        อนุมัติ
                        </label>
                    </div>
                </div>

            </div>

            {/* Form Actions */}
            <div className="mt-8 flex justify-end">
                <button
                type="button"
                onClick={() => navigate("/panel/employee")}
                className="mr-4 px-6 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors"
                >
                ยกเลิก
                </button>
                <button
                type="submit"
                className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                >
                บันทึกข้อมูล
                </button>
            </div>
        </form>

    
    </div>
  );
};

export default EmployeeAdd;